import _ from 'underscore';
import $ from 'jquery';

import BaseComponent from 'source/lib/base_component';

const BaseInput = BaseComponent.extend({
    name: 'base-input',
    classPrefix: 'input-light__',
    template(data) {
        return `<input type="${data.type}">`;
    },
    initialize(...args) {
        _.extend(this.events, {
            'focus .js-input': 'setFocus',
            'blur .js-input': 'lostFocus',
            'mouseover .js-input': 'setHover',
            'mouseout .js-input': 'lostHover',
        });
        BaseComponent.prototype.initialize.apply(this, args);
        this.$root = $('#js-view');
        this.$root.on('component:all:error', _.bind(this.onErrorUpdate, this));
        this.$inputWrapper = this.$('.js-input-wrapper');
        this.delegateEvents();
    },
    events: {
        keyup: 'keyup',
        change: 'change',
    },
    setFocus() {
        this.$inputWrapper.addClass(`${this.classPrefix}focus`);
    },
    lostFocus() {
        this.$inputWrapper.removeClass(`${this.classPrefix}focus`);
    },
    setHover() {
        this.$inputWrapper.addClass(`${this.classPrefix}hover`);
    },
    lostHover() {
        this.$inputWrapper.removeClass(`${this.classPrefix}hover`);
    },
    keyup(event) {
        // TODO: remove submit enable from keyup or change
        this.components.proxyEvent('form:submit:enable', event, this);
        if (event.keyCode === 13) { // enter key
            return;
        }
        // Не очищаем ошибки если поле readonly
        if (!event.target.readOnly) {
            this.components.proxyEvent('error:clear', event, this);
        }
    },
    getValue() {
        return this.$('.js-input').val();
    },
    setValue(value) {
        this.$('.js-input').val(value);
    },
    change(event) {
        this.value = event.target.value;
        this.components.proxyEvent('change', event, this);
        this.components.proxyEvent('form:submit:enable', event, this);
    },
    onErrorUpdate(event) {
        this.components.proxyEvent('change', event, this);
    },
});

export default BaseInput;
